import { act } from 'react-dom/test-utils';
import ReactTestUtils from 'react-dom/test-utils';
// simulate events for both polaris and regular elements
const buildEventSimulator = event => wrapper => act(() => {
    const element = wrapper.getElement();
    // polaris element
    if (element.constructor.name === 'HTMLUnknownElement') {
        wrapper[event]();
    }
    else {
        // regular element
        ReactTestUtils.Simulate[event](element);
    }
});
export const Click = buildEventSimulator('click');
//# sourceMappingURL=Events.js.map